<template>
  <div
    v-if="answer && answer.arrayValue && answer.arrayValue.answers && Object.keys(answer.arrayValue.answers).length"
    :class="'answer --' + answer.writerProfile"
  >
    <div :class="'answer__content' + (questionnaire.useComments && !disabled ? ' -comments' : '')">
      <div>
        <QuestionnaireAnswerValueComponent :type="item.type" :answers="answer.arrayValue.answers" />
        <div class="answer__comment" v-if="answer?.arrayValue?.comments">
          {{ item.commentsLabel ? item.commentsLabel : $t("empty_comment_label") }}
          :<br />{{ answer.arrayValue.comments }}
        </div>
      </div>
      <QuestionnaireAddCommentComponent
        v-if="!disabled"
        :answer="answer"
        :commenting="commenting"
        :item="item"
        :onQuestion="false"
        @draft="draft"
        @toggleComment="toggleComment"
        @commentAdded="commentAdded"
        @isLoading="isLoading"
      />
    </div>
    <div class="answer__heading">
      <div class="answer__identity">{{ answer.writerName }}</div>
    </div>
  </div>
  <div class="comments">
    <QuestionnaireCommentComponent v-if="answerItem.answerComments" :comments="answerItem.answerComments" />
  </div>
</template>

<script>
import QuestionnaireCommentComponent from "@/components/questionnaire/QuestionnaireCommentComponent.vue";
import { dateFormatter } from "@/services/utilities/date-formatter";
import { loginManager } from "@/services/security/login-manager";
import QuestionnaireAddCommentComponent from "@/components/questionnaire/QuestionnaireAddCommentComponent.vue";
import { mapState } from "pinia";
import { usePlatformStore } from "@/store/platform/platform";
import { useQuestionnaireStore } from "@/store/questionnaire/questionnaire";
import QuestionnaireAnswerValueComponent from "@/components/questionnaire/QuestionnaireAnswerValueComponent.vue";

export default {
  name: "QuestionnaireAnswerComponent",
  components: {
    QuestionnaireAnswerValueComponent,
    QuestionnaireAddCommentComponent,
    QuestionnaireCommentComponent,
  },
  props: {
    answer: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      commenting: false,
      commentModel: null,
      answerItem: this.answer,
    };
  },
  computed: {
    ...mapState(usePlatformStore, {
      apprenticeProfileLabel: (store) => store.apprenticeProfileLabel,
      tutorProfileLabel: (store) => store.tutorProfileLabel,
      apprenticeMasterProfileLabel: (store) => store.apprenticeMasterProfileLabel,
      studeaManagerProfileLabel: (store) => store.studeaManagerProfileLabel,
    }),
    ...mapState(useQuestionnaireStore, {
      questionnaire: (store) => store.questionnaire,
    }),
  },
  methods: {
    formatDate(date, type = "short") {
      return dateFormatter.format(date, type);
    },

    isPicture() {
      if (this.answer && this.answer.arrayValue && this.answer.arrayValue.answers) {
        return new RegExp("([./])(gif|jpe?g|png)$").test(this.answer.arrayValue.answers.pathName);
      }
      return false;
    },

    fileDownloadLink() {
      const platform = loginManager.getApiPath().slice(0, -3);
      if (this.answer && this.answer.arrayValue && this.answer.arrayValue.answers) {
        return (
          platform +
          "download-file/path-name-" +
          this.answer.arrayValue.answers.pathName +
          "/original-name-" +
          this.answer.arrayValue.answers.originalName
        );
      }
      return "";
    },

    fileSrc() {
      const platform = loginManager.getApiPath().slice(0, -3);
      if (this.answer && this.answer.arrayValue && this.answer.arrayValue.answers) {
        return (
          platform +
          "inline-file/path-name-" +
          this.answer.arrayValue.answers.pathName +
          "/original-name-" +
          this.answer.arrayValue.answers.originalName
        );
      }
      return "";
    },

    toggleComment() {
      this.commenting = !this.commenting;
    },

    commentAdded(payload) {
      this.answerItem.answerComments.push(payload.comment);
    },

    isLoading(loading) {
      this.$emit("isLoading", loading);
    },

    draft(model) {
      this.$emit("draft", model);
    },
  },
};
</script>

<style lang="scss" scoped>
.answer {
  padding: 8px 20px;
  display: flex;
  justify-content: space-between;
  border-top: 1px dashed $m-color_4;
  position: relative;

  &__content {
    padding-right: 20px;
    @include dark-theme {
      color: $white;
    }

    &.-comments {
      padding-left: 30px;
    }
  }

  &__comment {
    white-space: pre-line;
  }

  &__image {
    max-height: 150px;
    text-align: center;
    display: block;

    img {
      max-height: 150px;
      width: auto;
      object-fit: contain;
      display: inline-block;
    }
  }

  &.--1 {
    --profile-color: #6ac7a4;
  }

  &.--2 {
    --profile-color: #546bd1;
  }

  &.--3 {
    --profile-color: #da5164;
  }

  &.--4 {
    --profile-color: #f8a007;
  }

  &__heading {
    display: flex;
    justify-content: space-between;
    font-weight: 700;
    margin-bottom: 5px;
    color: var(--profile-color);
  }
}

.comments {
  padding: 0 20px;
}
</style>
